import { useQuery } from '@tanstack/react-query';
import {
  getDashboardStats, type DashboardStatsParams 
} from '../api';

export function useDashboardStats(params: DashboardStatsParams) {
  return useQuery({
    queryKey: ['dashboard-stats', params],
    queryFn: () => getDashboardStats(params),
    enabled: Boolean(params.siteId),
  });
}
